import { ValidationResult } from '../engine.js';
import { castCompatibleValue, isRestrictedTo, noRestrictions, restrictedTo } from './CompatibleValues.js';
export class CompatibilityService {
    constructor(schema) {
        this.schema = schema;
        this.tables = new Map();
        this.options = [];
    }
    getAvailableCompatibleValues(propertyPath) {
        const values = new Set();
        let compatibleValuesSets = 0;
        for (const table of this.tables.values()) {
            const tableAvailableCompatibleValues = table.getAvailableCompatibleValues(propertyPath);
            if (isRestrictedTo(tableAvailableCompatibleValues)) {
                compatibleValuesSets++;
                for (const value of tableAvailableCompatibleValues.values) {
                    values.add(value);
                }
            }
        }
        if (compatibleValuesSets > 0) {
            return restrictedTo(castCompatibleValue([...values]));
        }
        return noRestrictions();
    }
    getCompatibleWithModelValues(model, propertyPath) {
        const values = new Set();
        let compatibleValuesSets = 0;
        for (let table of this.tables.values()) {
            const compatibleWithModelValues = table.getCompatibleWithModelValues(model, propertyPath);
            if (isRestrictedTo(compatibleWithModelValues)) {
                compatibleValuesSets++;
                for (const value of compatibleWithModelValues.values) {
                    values.add(value);
                }
            }
        }
        if (compatibleValuesSets > 0) {
            return restrictedTo(castCompatibleValue([...values]));
        }
        else {
            return noRestrictions();
        }
    }
    addCompatibilityTable(compatibilityTable, tableName) {
        this.tables.set(tableName, compatibilityTable);
    }
    validate(model) {
        for (const [tableName, table] of this.tables) {
            const error = table.validate(model);
            if (error !== null) {
                return ValidationResult.Error(`Incompatible model for ${tableName} table. ${error}`);
            }
        }
        return ValidationResult.Valid();
    }
    getCompatibilityInvolvedOptionPaths(model, typeRef) {
        const paths = new Set();
        const visitedTables = new Set();
        for (const table of this.tables.values()) {
            if (table.typeRef === typeRef && !table.isCompatibilitySwitchedOff(model)) {
                for (let path of table.getCompatibilityInvolvedOptionPaths()) {
                    paths.add(path);
                }
            }
        }
        return Array.from(paths);
    }
}
//# sourceMappingURL=CompatibilityService.js.map